import { CostBasisMethods } from '@interfaces/models/cost-basis-methods';
import { parseStrDefaultToZero } from '@sharedUtils';
import { CostBasisPosition } from '@store/reducers/cost-basis/cost-basis.reducer';
export interface RadioButtonContent {
  radioButton: string;
  description: string;
  link: {
    content: string;
    href: string;
  };
  value: string;
  disabled: boolean;
}

export type PositionUpdateRequest = { props: Partial<CostBasisPosition>; index: number };

export const getSelectedPositionsTotal = (selectedPositions: CostBasisPosition[]) => {
  return selectedPositions.reduce((accumulated, position) => {
    let value;
    if (position.settlementFund) {
      value = position.selectedAmount;
    } else {
      if (position.selectedCostBasisMethod === CostBasisMethods.SPECID)
        value = position.taxLotsTotalMarketValue;
      else {
        value =
          position.giftingMethod === 'SHARES'
            ? position.sharesTotalMarketValue
            : position.selectedAmount;
      }
    }

    return accumulated + parseStrDefaultToZero(value || '0');
  }, 0);
};
